export const AUDIENCE_LABELS = {
  all: "All customers",
  verified: "Email-verified customers",
  phone_verified: "Phone-verified customers",
  unverified: "Unverified customers",
};

const STATUS_STYLES = {
  draft: "bg-[#0000000D] text-[#4F4F4F]",
  sending: "bg-[#F2C94C33] text-[#B7791F]",
  sent: "bg-[#27AE601A] text-[#219653]",
  partially_sent: "bg-[#F2C94C33] text-[#B7791F]",
  failed: "bg-[#EB57571A] text-[#EB5757]",
};

export const CampaignStatus = ({ status }) => (
  <span
    className={`${STATUS_STYLES[status] || ""} rounded-[3px] px-[10px] py-[3px] text-[13px] capitalize whitespace-nowrap`}
  >
    {String(status || "").replace("_", " ")}
  </span>
);
